import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { toTitleCase } from '@/helpers/formatting';
import { SummerCyoOffer } from '@/models/leaderboard';
import { Routes } from '@/router';

@Component({
    name: 'CmgLeaderboardCyoRedemptionSuccessModal'
})

export default class CmgLeaderboardCyoRedemptionSuccessModal extends Vue {
    get offer(): SummerCyoOffer {
        return this.$appStore.state.ui.modals.summerLeaderboardCyoRedemptionSuccessModal.args!.offer;
    }

    get offerName(): string {
        return toTitleCase(this.offer.title);
    }

    get offerImage(): string {
        return this.offer.mediaUri;
    }

    get modalTitle(): string {
        return `${this.offerName}`;
    }

    get visible(): boolean {
        return this.$appStore.state.ui.modals.summerLeaderboardCyoRedemptionSuccessModal.visible;
    }   

    get isMobile(): boolean {
        return this.$services.ui.isMobile();
    }

    get lottieBackgroundSparklesUrl(): string {
        return this.$appStore.state.cms.animations.bag.lottieBackgroundSparklesUrl;
    }

    get description(): string {
        return this.offer.offerType.toLocaleLowerCase() === 'points'
            ? `1,625 extra points have been added to your point balance.`
            : `${this.offerName} has been added to My Rewards.`;
    }

    get showTermsAndConditions(): boolean {
        return this.offer.offerType.toLocaleLowerCase() === 'reward' && !!this.offer.terms;
    }

    get ctaText(): string {
        return this.offer.offerType.toLowerCase() === "reward" ? 'see rewards' : 'exchange points';
    }

    onClickTermsAndConditions(event: any) {
        const offer = this.offer;
        const onBack = () => {
            this.$services.ui.setModalVisibility('summerLeaderboardCyoRedemptionSuccessModal', true, { offer });
            this.$services.ui.setModalVisibility('rewardTermsAndConditions', false);
        };

        this.$services.ui.pushEventTargetAsLastSelectedElement(event);
        this.$services.ui.setModalVisibility('rewardTermsAndConditions', true, { termsAndConditions: offer.terms, onBack });
        this.$services.ui.firstFocus();
        this.$services.ui.setModalVisibility('summerLeaderboardCyoRedemptionSuccessModal', false);
    }

    setLoadingStatus(loading: boolean) {
        this.$services.ui.setAppBlur(loading);
        this.$services.ui.setAppPepperVisibility(loading);
    }

    async onClickCtaButton() {
        this.$router.push({ name: Routes.RewardsExchange });   
        this.onClose(); 
    }

    onClose() {
        this.$services.ui.setModalVisibility('summerLeaderboardCyoRedemptionSuccessModal', false);
    }
}